import { memo } from 'react';

import { ToastContainerComponent } from './components/ui/toast';
import type { ThemeProviderProps } from './theme';
import { ThemeProvider } from './theme';

const UIProvider = memo(({ children, ...props }: ThemeProviderProps) => (
  <ThemeProvider {...props}>
    {children}

    <ToastContainerComponent />
  </ThemeProvider>
));

export { UIProvider };
